import { render, staticRenderFns } from "./EliminateCategory.vue?vue&type=template&id=4e6c3049"
import script from "./EliminateCategory.vue?vue&type=script&lang=js"
export * from "./EliminateCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports